<template>
  <div class="main-body">
    <div class="header">活动记录</div>
    <div class="out">

      <div class="search2">

        <div style="float:right;">

          <el-select v-model="commandCenterCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_comm"
                :key="item.commandCenterCode"
                :label="item.name"
                :value="item.commandCenterCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="activityContentName" label="活动内容" fixed width="150"></el-table-column>

        <el-table-column prop="practiceSiteName" label="实践中心" width="150"></el-table-column>
        <el-table-column prop="volunteerTeamName" label="志愿队伍" width="150"></el-table-column>

        <el-table-column prop="activityAddress" label="活动地址" width="250"></el-table-column>
        <el-table-column prop="activityStartTime" :formatter="timefilter" label="开始时间" width="180"></el-table-column>
        <el-table-column prop="activityEndTime" :formatter="timefilter" label="结束时间"  width="180"></el-table-column>

        <el-table-column prop="elderlyCount" label="参与人数"  width="100"></el-table-column>

        <el-table-column prop="isShow" label="对外展示" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.isShow ==1">展示</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handlePhoto(scope.$index, scope.row)">查看照片</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Photo ref="myPhoto" v-show="showModalPhoto" v-on:closePhoto="closePhoto"></Photo>


  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

import Photo from "../CommandCenter/Photo";

export default {
  name: "Page",

  data(){
    return{

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,




      showModalAdd:false,
      showModalEdit:false,
      showModalPhoto:false,

      th:0,


      arr_comm:[],
      commandCenterCode: '',

    }
  },
  created(){
    this.getComm();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Photo
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{



    getComm(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CommandCenter/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_comm = response.data.data.list;
          if(this.arr_comm.length>0){
            this.commandCenterCode = this.arr_comm[0].commandCenterCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    timefilter(row,index,column){
      return timefilters(column).slice(0,16)
    },



    search(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/GovPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          commandCenterCode:this.commandCenterCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },



    handlePhoto(index, row) {
      this.$refs.myPhoto.init(row);
      this.showModalPhoto = !this.showModalPhoto;
    },
    closePhoto:function(){
      this.showModalPhoto = !this.showModalPhoto;
    },


  }
}
</script>

<style scoped>

</style>
